<template>
  <footer class="c-footer">
    <FagbokforlagetIcon class="c-footer__logo" />
    <div class="c-footer__links">
      <button class="c-footer__link c-footer__link-cookie" rel="noopener" @click="onCookieLinkClick">
        <CookieIcon class="c-footer__icon" />
        <span class="c-footer__text">{{ $t('FOOTER.COOKIE') }}</span>
      </button>
      <a class="c-footer__link" href="https://fagbokforlaget.no/side/personvernerklaering">
        <PrivacyIcon class="c-footer__icon" />
        <span class="c-footer__text">{{ $t('FOOTER.PRIVACY') }}</span>
      </a>
      <a class="c-footer__link" href="https://fagbokforlaget.no/side/kontaktinformasjon">
        <ContactIcon class="c-footer__icon" />
        <span class="c-footer__text">{{ $t('FOOTER.CONTACT') }}</span>
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
import FagbokforlagetIcon from '@/assets/icons/FagbokforlagetIcon.vue';
import ContactIcon from '@/assets/icons/ContactIcon.vue';
import PrivacyIcon from '@/assets/icons/PrivacyIcon.vue';
import CookieIcon from '@/assets/icons/CookieIcon.vue';

const onCookieLinkClick = () => window.dispatchEvent(window.CookieModal.consts.COOKIE_MODAL_EVENT_OPEN);
</script>
